export const typography = {
  fontFamily: '"Poppins", sans-serif',
  fontSize: 16,
  fontWeight: 400,
  h1: {
    fontSize: 66,
    fontWeight: 600,
    lineHeight: 1.4,
    '@media (max-width:1535px)': { fontSize: '52px' },
    '@media (max-width:1279px)': { fontSize: '44px' },
    '@media (max-width:1023px)': { fontSize: '32px' },
    '@media (max-width:639px)': { fontSize: '28px' },
  },
  h2: {
    fontSize: 66,
    fontWeight: 600,
    lineHeight: 1.4,
    '@media (max-width:1535px)': { fontSize: '52px' },
    '@media (max-width:1279px)': { fontSize: '44px' },
    '@media (max-width:1023px)': { fontSize: '32px' },
    '@media (max-width:639px)': { fontSize: '28px' },
  },
  h3: {
    fontSize: 42,
    fontWeight: 600,
    lineHeight: 1.3,
    '@media (max-width:1535px)': { fontSize: '32px' },
    '@media (max-width:1279px)': { fontSize: '28px' },
    '@media (max-width:639px)': { fontSize: '24px' },
  },
  h4: {
    fontSize: 32,
    fontWeight: 600,
    lineHeight: 1.3,
    '@media (max-width:1535px)': { fontSize: '26px' },
    '@media (max-width:639px)': { fontSize: '22px' },
  },
  h5: {
    fontSize: 22,
    fontWeight: 600,
    lineHeight: 1.5,
    '@media (max-width:1535px)': { fontSize: '18px' },
    '@media (max-width:639px)': { fontSize: '16px' },
  },
  h6: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.6,
    '@media (max-width:1535px)': { fontSize: '14px' },
  },
  body16: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.7,
    '@media (max-width:1535px)': { fontSize: '14px' },
  },
  body14: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.7,
  },
};
